/**
 * A 40-line event emitter so that nothing in @pine/core depends on Node's
 * `events`. The same bundle then runs unmodified on Node, Bare and in a
 * browser without a polyfill.
 */
export class Emitter {
  constructor () {
    this._handlers = new Map()
  }

  on (event, fn) {
    let set = this._handlers.get(event)
    if (!set) this._handlers.set(event, (set = new Set()))
    set.add(fn)
    return () => this.off(event, fn)
  }

  once (event, fn) {
    const off = this.on(event, (...args) => {
      off()
      fn(...args)
    })
    return off
  }

  off (event, fn) {
    const set = this._handlers.get(event)
    if (set) set.delete(fn)
  }

  emit (event, ...args) {
    const set = this._handlers.get(event)
    if (!set) return
    for (const fn of [...set]) {
      try {
        fn(...args)
      } catch (err) {
        if (event !== 'error') this.emit('error', err)
      }
    }
  }

  removeAllListeners () {
    this._handlers.clear()
  }
}
